// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
// THIS FILE WAS AUTOGENERATED
/**
 * Data struct to contain only C section with custom fields.
 */
var Base = /** @class */ (function () {
    function Base() {
    }
    return Base;
}());
export { Base };
//# sourceMappingURL=Base.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@microsoft/applicationinsights-common/dist-esm/Interfaces/Contracts/Generated/Base.js
// module id = 135
// module chunks = 1